window.dynamicHeader = function () {
    return {
        hidden: false,
        lastScroll: window.scrollY,
        scrollUpDelta: 0,
        stickyLimit: 200,
        thresholdUp: 100,
        init() {
            window.addEventListener('scroll', () => {
                const current = window.scrollY;
                const delta = current - this.lastScroll;

                if (current <= this.stickyLimit) {
                    this.hidden = false;
                } else {
                    if (delta > 0) {
                        // Down
                        this.scrollUpDelta = 0;
                        this.hidden = true;
                    } else {
                        // Up
                        this.scrollUpDelta += Math.abs(delta);
                        if (this.scrollUpDelta >= this.thresholdUp) {
                            this.hidden = false;
                        }
                    }
                }

                this.lastScroll = current;
            });
        },
    };
}

// Mega menu: opens on hover and on click, closes on leave, Escape and outside click
window.megaMenu = function () {
    return {
        open: false,
        openedBy: null,
        enter() {
            if (!this.open) {
                this.open = true;
                this.openedBy = 'hover';
            }
        },
        leave() {
            this.close();
        },
        toggle() {
            // A click on a menu that hover just opened keeps it open
            if (this.open && this.openedBy === 'hover') {
                this.openedBy = 'click';
                return;
            }
            this.open = !this.open;
            this.openedBy = 'click';
        },
        close(focusButton = false) {
            this.open = false;
            this.openedBy = null;
            if (focusButton) {
                this.$refs.button.focus();
            }
        },
    };
}
